
import { Button } from "@/components/ui/button";
import FooterAr from "@/components/FooterAr";
import HeaderAr from "@/components/HeaderAr";
import { Link } from "wouter";
import { 
  Lock, 
  FileText, 
  BarChart, 
  Library, 
  Calendar, 
  Mail 
} from "lucide-react";

const CreatorsAr = () => {
  return (
    <div className="min-h-screen bg-musicBlack" dir="rtl">
      <HeaderAr />
      <main className="pt-24">
        {/* Hero section */}
        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-r from-musicBlack to-musicBlack/80"></div>
            <img 
              src="/lovable-uploads/db7b1ce0-3582-4ece-8e2e-22fa36727311.png" 
              alt="مبدعو الموسيقى" 
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="relative z-10 editorial-container">
            <div className="max-w-3xl">
              <h1 className="editorial-heading mb-4">للمبدعين</h1>
              <h2 className="editorial-subheading text-musicRed">موسيقاك. حقوقك. أرباحك.</h2>
              <p className="editorial-body mb-6">
                كل صوت يترك صدى. أمة الموسيقى تمكّن الفنانين والشركات والمنتجين بالأدوات اللازمة لتسجيل وحماية واستثمار 
                أعمالهم الإبداعية عبر السوق الإماراتي.
              </p>
              <p className="editorial-body mb-8">
                فنك. قواعدك. تحكم في حقوق موسيقاك اليوم.
              </p>
              <Button className="cta-button" size="lg">سجل كمبدع</Button>
            </div>
          </div>
        </section>
        
        {/* Career Tools section */}
        <section className="py-24 bg-black">
          <div className="editorial-container">
            <div className="text-center mb-12">
              <h2 className="editorial-heading">
                <span className="text-musicGrey">أمة الموسيقى</span> تقدم مجموعة متنوعة من <span className="text-musicWhite">أدوات المهنة</span>
              </h2>
              <h3 className="editorial-subheading">لكتاب الأغاني والملحنين والناشرين</h3>
            </div>
            
            <div className="creator-tools-grid">
              <div className="creator-tool">
                <div className="creator-tool-icon">
                  <Lock size={28} />
                </div>
                <h3 className="creator-tool-title">تسجيل الدخول</h3>
                <p className="creator-tool-description">
                  ادخل إلى لوحة المبدع الخاصة بك لإدارة كتالوج الموسيقى وعرض تقارير الأتاوات وتحديث ملفك الشخصي.
                </p>
              </div>
              
              <div className="creator-tool">
                <div className="creator-tool-icon">
                  <FileText size={28} />
                </div>
                <h3 className="creator-tool-title">الأسئلة الشائعة</h3>
                <p className="creator-tool-description">
                  اعثر على إجابات للأسئلة الأكثر شيوعاً حول حقوق الموسيقى والأتاوات ولوائح حقوق الطبع والنشر الإماراتية.
                </p>
              </div>
              
              <div className="creator-tool">
                <div className="creator-tool-icon">
                  <BarChart size={28} />
                </div>
                <h3 className="creator-tool-title">الفوائد</h3>
                <p className="creator-tool-description">
                  تعرف على مزايا تسجيل موسيقاك مع أمة الموسيقى وكيف نساعد في تعظيم أرباحك.
                </p>
              </div>
              
              <div className="creator-tool">
                <div className="creator-tool-icon">
                  <Library size={28} />
                </div>
                <h3 className="creator-tool-title">النماذج</h3>
                <p className="creator-tool-description">
                  حمّل جميع النماذج اللازمة لتسجيل الموسيقى ومطالبات الأتاوات وطلبات العضوية.
                </p>
              </div>
              
              <div className="creator-tool">
                <div className="creator-tool-icon">
                  <Calendar size={28} />
                </div>
                <h3 className="creator-tool-title">التقويم</h3>
                <p className="creator-tool-description">
                  ابق على اطلاع بالتواريخ المهمة وجداول ورش العمل وفترات توزيع الأتاوات وأحداث الصناعة.
                </p>
              </div>
              
              <div className="creator-tool">
                <div className="creator-tool-icon">
                  <Mail size={28} />
                </div>
                <h3 className="creator-tool-title">اتصل</h3>
                <p className="creator-tool-description">
                  تواصل مع فريق دعم المبدعين للحصول على مساعدة شخصية في استفساراتك حول حقوق الموسيقى.
                </p>
              </div>
            </div>
          </div>
        </section>
        
        {/* CTA section */}
        <section className="py-16 bg-gradient-to-b from-black to-musicBlack">
          <div className="editorial-container">
            <div className="bg-musicRed/10 border border-musicRed/20 rounded-lg p-8 md:p-12">
              <div className="max-w-3xl mx-auto text-center">
                <h2 className="font-serif text-2xl md:text-3xl font-bold mb-4">هل أنت مستعد لحماية عملك الإبداعي؟</h2>
                <p className="text-musicGrey mb-8">
                  انضم إلى آلاف المبدعين الإماراتيين الذين يثقون في أمة الموسيقى لإدارة حقوقهم وتعظيم أرباحهم.
                </p>
                <Button className="bg-musicRed hover:bg-musicRedDark text-white transition-all duration-300 transform hover:scale-[1.02]" size="lg">سجل الآن</Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterAr />
    </div>
  );
};

export default CreatorsAr;
